import React from 'react';
import { CubeTransparentIcon, HomeIcon } from '@heroicons/react/24/outline';

const AdminNavigator = () => {
  const handleReturnToDashboard = () => {
    // Open admin dashboard with current token
    const token = localStorage.getItem('authToken');
    const adminUrl = process.env.NODE_ENV === 'development' 
      ? 'http://localhost:3004' 
      : window.location.origin.replace(':3002', ':3004');
    
    if (token) {
      window.open(`${adminUrl}#token=${token}`, '_blank');
    } else {
      window.open(adminUrl, '_blank');
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={handleReturnToDashboard}
        className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg shadow-lg transition-colors duration-200"
        title="Return to Cognitive Fabric Dashboard"
      >
        <CubeTransparentIcon className="h-5 w-5" />
        <span className="text-sm font-medium">Admin Dashboard</span>
      </button>
    </div>
  );
};

export default AdminNavigator;